import React from 'react';

import TextInput from '../../../TextInput';

const MAX_INPUT = 6;
const INPUT_WIDTH = 80;

const NumericAnswer = ({ tempId, selectedValue, onChange }) => (
  <TextInput
    limit={MAX_INPUT}
    style={{ width: INPUT_WIDTH }}
    type="number"
    name={tempId}
    value={selectedValue}
    isFractionNumber
    step="any"
    onChange={onChange}
  />
);

export default NumericAnswer;



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Answers/NumericAnswer/index.jsx